export default __webpack_public_path__ + "static/SRUS SPL4 - Especification Del Producto y Datos Técnicos-306ca4314b94f340b176c9970858f12f.pdf";